export default __webpack_public_path__ + "static/media/TUNZ_Token.d96cb795.png";